// client/src/pages/Game/Battlefield/components/TerrainSlot.jsx
import React from 'react';
import './TerrainSlot.css';

/**
 * Emplacement Terrain (au-dessus du deck joueur / en dessous du deck
 * adverse). R34w : affiche l'IMAGE RÉELLE de la carte terrain active et
 * un clic ouvre l'aperçu détaillé (comme les monstres).
 */
const TerrainSlot = ({ player, gameState, position, size, onCardClick, onDevDragStart, devMode }) => {
  const terrain = player === 'player' ? gameState?.playerTerrain : gameState?.opponentTerrain;
  const isMine = player === 'player';

  const handleClick = (e) => {
    if (devMode) return;
    e.stopPropagation();
    if (terrain && onCardClick) onCardClick(terrain);
  };

  const elSlug = String(terrain ? (terrain.element || 'fire') : 'fire').toLowerCase();
  const imgSrc = terrain
    ? (terrain.imageUrl || ('/api/static/images/cards/' + (terrain.id || terrain.definitionId) + '.webp'))
    : null;
  const fallbackSrc = '/api/static/images/cards/' + elSlug + '.svg';
  const title = terrain
    ? 'Terrain ' + (isMine ? '(vôtre)' : 'adverse') + ' : ' + terrain.name
      + (terrain.duration !== undefined ? ' (' + terrain.duration + ' tour(s) restant(s))' : '')
      + ' — cliquez pour les détails'
    : 'Emplacement terrain (vide)';

  return (
    <div
      className={`game-element terrain-zone ${player}-terrain ${terrain ? 'terrain-active' : ''} ${terrain && !isMine ? 'terrain-enemy' : ''}`}
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
        width: `${size.width}cqw`,
        height: `${size.height}cqw`,
        transform: 'translate(-50%, -50%)',
      }}
      data-terrain={player}
      onMouseDown={devMode && onDevDragStart ? (e) => onDevDragStart(e) : undefined}
      onClick={handleClick}
      title={title}
    >
      {terrain ? (
        <div className="terrain-card">
          <img
            className="terrain-card-img"
            src={imgSrc}
            alt={terrain.name || 'Terrain'}
            draggable={false}
            onError={(e) => {
              if (!e.target.dataset.fb) { e.target.dataset.fb = '1'; e.target.src = fallbackSrc; }
              else e.target.style.display = 'none';
            }}
          />
          {terrain.duration !== undefined && terrain.duration > 0 && (
            <span className="terrain-duration">{terrain.duration}</span>
          )}
        </div>
      ) : (
        <div className="terrain-empty">
          <span className="terrain-symbol">⛰</span>
        </div>
      )}
      <div className="terrain-label">TERRAIN</div>
    </div>
  );
};

export default TerrainSlot;
